module.exports = __webpack_public_path__ + "resources/post_default_cover.7c166975f0cfb47c.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-rcmd/img/post_default_cover.png
// module id = 753
// module chunks = 0 2